import React from "react";
import { Link } from "react-router-dom";
import Slick from "react-slick";

import "./styles.css";

const Render = (props, context) => {
  return (
    <section className="cambiarSuperheroe pbxl backgroundHomeCard">
      
      <div className="container">
        <ul className="breadcrumbs horizontal clearfix">
          <li>
            <Link to="/" className="avenirBK white">
              Perfil
            </Link>
          </li>
          <li>
            <h1 className="avenirBK white">Cambiar Superhéroe</h1>
          </li>
        </ul>


        <Slick
          className="seleccionUl horizontal clearfix mask pbl"
          afterChange={props.onChange}
        >
          {props.avatars.map(avatar => (
            <li key={avatar.id}>
              <img
                src={`${avatar.fullImage}`}
                alt="Superhéroe Uno."
                className="displayBlock mha"
              />
            </li>
          ))}
        </Slick>
        {/* <ul className="cambiarSuperheroeUl horizontal clearfix">
          {props.avatars
            .filter(avatar => avatar.name !== "0" && avatar.level === 1)
            .map(avatar => {
              return (
                <li className="borderBox" key={avatar.id}>
                  <a
                    className="displayBlock pRel hoverGrow mha"
                    onClick={props.onSelect.bind(null, avatar.name)}
                  >
                    <img
                      src={`${avatar.icon}`}
                      alt="Superhéroe Uno."
                      className="displayBlock fullWidth mha"
                    />
                  </a>
                </li>
              );
            })}
        </ul> */}

        <ul className="btnUl unstyled">
          <li>
            <a onClick={props.onSubmit} className="btn btnGold mha">
              Seleccionar
            </a>
          </li> 
          <li>
            <Link to="/dashboard" className="btn btnVolver mha">
              &lt; Cancelar
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/SuperheroeCambiar/Render.js